var jq$ = jQuery;
/* reviews slider */
jq$('#slick--template--17734420529205__pdp_icons_mRcw7T').slick({
    dots: false,
    infinite: true,
    arrows:true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

/* hero slider - word change */
jq$('.hero-slider').slick({
    autoplay: true,
    arrows: false,
    centerPadding: "10px",
    draggable: false,
    infinite: true,
    pauseOnHover: false,
    swipe: false,
    touchMove: false,
    vertical: true,
    verticalScrolling: true,
    speed: 1000,
    autoplaySpeed: 2000,
    useTransform: true,
    cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
    adaptiveHeight: true
  });


/* as seen in section */
jq$('.feat-logos-sc .content-two .product-specs.count-4').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: false,
   fade: true,
    autoplay: true,
    autoplaySpeed: 2500,
});
jq$('#slick--template--17734420529205__pdp_icons_v2_VJCxjC').slick({
   slidesToShow: 2,
   slidesToScroll: 1,
   asNavFor: '.feat-logos-sc .content-two .product-specs.count-4',
   dots: false,
   centerMode: false,
   focusOnSelect: true,

});

$('.feat-logos-sc .content-two .product-specs.count-4').on('beforeChange', function(event,slick,slide,nextSlide) {
    $('#slick--template--17734420529205__pdp_icons_v2_VJCxjC').find('.slick-slide').removeClass('slick-current yada').eq(nextSlide).addClass('slick-current yada');
});

jq$(document).ready(function($) {
    //$(".faq-question.initial, #faq-accordion_hz7FQ8 .initial").trigger('click');
});